import styled, { keyframes } from 'styled-components';
import { TotalTrackerContainer } from './index';

const ToggleBarMinHeight = 75;
const MobileDrawerBg = 'var(--lolas-clear-ocean-200)';

const Bounce = keyframes`
0% {
  height: ${ToggleBarMinHeight}px;
}
65% {
  height: 82vh;
}
80% {
  height: 79vh;
}
100%{
  height: 80vh;
}
`;

const Contract = keyframes`
to {
  height: ${ToggleBarMinHeight}px;
}
`;

const MobileSelectionToggleBar = styled.div`
  height: ${ToggleBarMinHeight}px;
  width: 100%;
  background-color: ${MobileDrawerBg};
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  padding: 1rem;
  bottom: 0;
  left: 0;
  z-index: 2;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;

  & > div {
    position: relative;
    width: 100%;
    max-width: 650px;
    height: 100%;
  }

  &.expanded ${MobileSelectionTopbar} .toggle-arrow svg {
    transform: rotateZ(180deg);
  }

  & > div .toggle-arrow {
    position: absolute;
    top: -27.5px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    width: 90px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20px;
    cursor: pointer;

    svg path {
      stroke: var(--lolas-pacific-500);
    }
  }
`;

const MobileSelectionTopbar = styled.div`
  background-color: #f4f4f4;
  height: ${(props) =>
    props.$expanded ? 'auto' : ToggleBarMinHeight - 30 + 'px'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: transparent;

  &::before {
    content: '';
    cursor: pointer;
    width: 100px;
    height: 40px;
    border-radius: 30px;
    background: red;
    position: absolute;
    left: 50%;
    top: -28.5px;
    transform: translateX(-50%);
    background-color: ${MobileDrawerBg};
    z-index: -1;
  }

  & ${TotalTrackerContainer} {
    margin-top: 0;
    margin-bottom: 0.5rem;
  }
`;

const ScrollOuter = styled.div`
  & .scroll-inner {
    padding: 1rem;
  }

  @media screen and (max-width: 768px) {
    max-height: calc(100% - 57px);
    overflow-y: auto ;
  }
`;

const MobileEditBtn = styled.span`
  text-align: right;
  font-size: 0.813rem;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 0.2rem;
  color: var(--lolas-pacific-500);

  opacity: 1;
  &.hidden {
    opacity: 0;
  }

  transition: opacity 0.25s linear;
`;

const MobileSelectionItemRemove = styled.span`
  position: absolute;
  top: 0.25rem;
  right: 0.75rem;
  height: 25px;
  width: 25px;

  svg {
    width: 100%;
  }

  @media screen and (max-width: 576px) {
    height: 18px;
    width: 18px;
    top: 0.15rem;
    right: 0.6rem;f
  }
`;

export {
  MobileSelectionToggleBar,
  MobileSelectionTopbar,
  ScrollOuter,
  MobileSelectionItemRemove,
  MobileEditBtn,
  MobileDrawerBg,
};
